import { cache } from 'react';
import { sitecoreClient } from './graphql-request';
import { Locale } from '@/i18n/i18n.config';

export const cacheGlobalSetting = cache(async (lang: Locale) => {
    return await sitecoreClient.globalSettingQuery({ lang });
});

export const cacheGeneralPage = cache(async ({ path, lang }: { path: string; lang: Locale }) => {
    return await sitecoreClient.generalPageQuery({
        path,
        lang,
    });
});

export const cacheWhitelistPage = cache(async (lang?: Locale) => {
    return await sitecoreClient.whitelistQuery({
        lang,
    });
});